import { getAuth } from "firebase/auth";
import { get, getDatabase, ref, update } from "firebase/database";
import "../Firebase";

const auth = getAuth();

let db = getDatabase();
export const getProfile = async () => {
  const allowed = [
    "username",
    "email",
    "profile_picture",
    "experience",
    "birthday",
    "gender",
    "softPower",
    "hardPower",
    "motivation",
    "deeds",
    "applyTeam",
    "igLink",
    "fbLink",
    "linkedInLink",
    "teamId"
  ];

  let snapshot = await get(ref(db, `users/${auth.currentUser.uid}`));
  if (snapshot.exists()) {
    var profile = snapshot.val();
    profile = Object.keys(profile)
      .filter((key) => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = profile[key];
        return obj;
      }, {});
    if (!profile.username)  profile.username = ""
    if (!profile.gender)  profile.gender = ""
    if (!profile.email)  profile.email = ""
    if (!profile.profile_picture)  profile.profile_picture = ""
    if (!profile.experience)  profile.experience = ""
    if (!profile.birthday)  profile.birthday = ""
    if (!profile.softPower)  profile.softPower = ""
    if (!profile.hardPower)  profile.hardPower = ""
    if (!profile.motivation)  profile.motivation = ""
    if (!profile.deeds)  profile.deeds = ""
    if (!profile.applyTeam)  profile.applyTeam = ""
    if (!profile.igLink)  profile.igLink = ""
    if (!profile.fbLink)  profile.fbLink = ""
    if (!profile.linkedInLink)  profile.linkedInLink = ""
    if (!profile.teamId)  profile.teamId = ""

    console.log(profile)
    return profile;
  }

  return null;
};

export const getUserProfile = async (id) => {
  const allowed = [
    "username",
    "email",
    "profile_picture",
    "experience",
    "birthday",
    "gender",
    "softPower",
    "hardPower",
    "motivation",
    "deeds",
    "igLink",
    "fbLink",
    "linkedInLink"
  ];

  let snapshot = await get(ref(db, `users/${id}`));
  if (snapshot.exists()) {
    var profile = snapshot.val();
    profile = Object.keys(profile)
      .filter((key) => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = profile[key];
        return obj;
      }, {});
    return profile;
  }

  return null;
};

export const saveProfile = (profile) => {
  update(ref(db, `users/${auth.currentUser.uid}`), profile ?? {});
};
